<template>
  <div class="review container">
    <div class="box">
      <el-page-header @back="$router.go(-1)" content="考试批阅">
      </el-page-header>
      <div class="head">
        <h3 class="task-name">{{ $route.query.examTitle }}</h3>
        <el-button
          class="export_btn"
          type="primary"
          icon="el-icon-download"
          size="small"
          @click="onExport"
          >成绩导出</el-button
        >
        <!-- <div v-show="selectedIds.length != 0" style="float: right">
          <el-button
            type="primary"
            size="small"
            plain
            @click="showReviewBatch = true"
            >批量打分</el-button
          >
          <el-button type="danger" size="small" plain @click="handleBackBatch"
            >批量打回</el-button
          >
        </div> -->
      </div>
      <div class="main">
        <el-form
          :model="searchForm"
          class="search_form"
          :inline="true"
          size="small"
        >
          <el-form-item prop="query">
            <el-input
              v-model="searchForm.query"
              placeholder="请输入学号或者姓名"
              ><el-button
                slot="append"
                size="small"
                icon="el-icon-search"
                @click="getList"
              ></el-button
            ></el-input>
          </el-form-item>
          <el-form-item prop="submitted"
            ><el-radio-group v-model="searchForm.submitted" @change="getList">
              <el-radio-button :label="true">已交</el-radio-button>
              <el-radio-button :label="false">未交</el-radio-button>
            </el-radio-group></el-form-item
          >
          <el-form-item style="float: right; margin-right: 0">
            <p style="color: #909399">
              全部 <b>{{ info.total }}</b> 名学生，已交
              <b>{{ info.submittedCount }}</b
              >，未交 <b>{{ info.notSubmittedCount }}</b>
            </p>
          </el-form-item>
        </el-form>
        <el-table
          class="student-list"
          :data="studentList"
          @selection-change="handleSelectionChange"
          stripe
        >
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column
            prop="nickName"
            label="姓名"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="sno" label="学号" width="120" align="center">
          </el-table-column>
          <el-table-column
            prop="receiveTime"
            label="领取时间"
            width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="submitTime"
            label="提交时间"
            width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="leave"
            label="切屏次数"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态"
            :formatter="statusformatter"
            width="120"
            align="center"
            :filters="[
              { text: '待批阅', value: 'SUBMITTED' },
              { text: '已批阅', value: 'REVIEWED' },
            ]"
            :filter-method="filterStatus"
          >
          </el-table-column>
          <el-table-column
            prop="reviewTime"
            label="批阅时间"
            width="150"
            align="center"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="reviewer"
            label="批阅人"
            width="100"
            align="center"
          >
          </el-table-column> -->
          <el-table-column
            prop="score"
            label="成绩"
            width="100"
            align="center"
            sortable
          >
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope" v-if="scope.row.status">
              <el-button
                @click="handelReview(scope.row.receiveId)"
                type="text"
                size="small"
                >{{
                  scope.row.status == "REVIEWED" ? "重新批阅" : "批阅"
                }}</el-button
              >
              <el-button
                @click="handelBack(scope.row.receiveId)"
                type="text"
                size="small"
                >打回</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="foot_page">
          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :page-size="searchForm.limit"
            :current-page.sync="searchForm.page"
            :total="total"
            @current-change="pageChange"
          ></el-pagination>
        </div> -->
      </div>
    </div>

    <el-dialog
      title="批量打分"
      :visible.sync="showReviewBatch"
      width="30%"
      center
    >
      <div style="text-align: center">
        <p style="margin-bottom: 20px; color: #909399">
          选中{{ selectedIds.length }}名学生
        </p>
        总分
        <el-input-number
          v-model="batchScore"
          :min="0"
          :controls="false"
          size="small"
        ></el-input-number>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="showReviewBatch = false"
          >取 消</el-button
        >
        <el-button type="primary" size="medium" @click="handleReviewBatch"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { reviewList, reviewNum, reviewBack } from "@/api/exam";
export default {
  data() {
    return {
      info: {},
      searchForm: {
        releaseId: this.$route.query.releaseId,
        query: "",
        submitted: true,
      },
      studentList: [],
      selectedIds: [],
      batchScore: undefined,
      showReviewBatch: false,
    };
  },
  created() {
    this.getNum();
    this.getList();
  },
  mounted() {
    this.timer = setInterval(this.localAdd, 2000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    getNum() {
      reviewNum({ releaseId: this.$route.query.releaseId }).then(
        ({ code, data, msg }) => {
          if (code == 0) {
            this.info = data;
          } else {
            this.$message.error(msg);
          }
        }
      );
    },
    // 列表
    getList() {
      this.$loading.show();
      reviewList(this.searchForm).then(({ code, data, msg }) => {
        this.$loading.hide();
        if (code == 0) {
          this.studentList = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    localAdd() {
      if (localStorage.getItem("isRefresh") == "true") {
        localStorage.setItem("isRefresh", false);
        this.getNum();
        this.getList();
      }
    },
    statusformatter(row) {
      if (row.status == "INIT") {
        return "考试中";
      } else if (row.status == "SUBMITTED") {
        return "待批阅";
      } else if (row.status == "REVIEWED") {
        return "已批阅";
      } else {
        return "待做";
      }
    },
    filterStatus(value, row) {
      return row.status === value;
    },
    handleSelectionChange(selection) {
      this.selectedIds = selection.map((item) => item.id);
    },
    // 批阅
    handelReview(receiveId) {
      const { href } = this.$router.resolve({
        path: "/classCourse/exam/review/detail",
        query: {
          id: this.$route.query.id,
          receiveId,
        },
      });
      window.open(href, "_blank");
    },
    handleReviewBatch() {
      this.showReviewBatch = false;
    },
    // 打回
    handelBack(receiveId) {
      this.$confirm("确定要打回学生试卷吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          reviewBack(receiveId).then(({ code, msg }) => {
            this.$loading.hide();
            if (code == 0) {
              this.$message.success("已成功打回");
              this.getList();
              this.getNum();
            } else {
              this.$message.error(msg);
            }
          });
        })
        .catch(() => {});
    },
    // 成绩导出
    onExport() {
      let token = localStorage.getItem("token");
       window.open(
          `${process.env.VUE_APP_API_DOMAIN}/app/teacher/exam/release/receive/export?releaseId=${this.$route.query.releaseId}&Authorization=${token}`
        );
    },
    handleBackBatch() {
      this.handelBack(this.selectedIds);
    },
    pageChange() {},
  },
};
</script>

<style lang="less" scoped>
.review {
  height: 100%;
  text-align: left;
  .box {
    padding: 25px 35px;
    background-color: #fff;
    ::v-deep .el-page-header {
      .el-page-header__content {
        font-size: 16px;
      }
    }
    .head {
      margin: 10px 0;
      line-height: 33px;
      overflow: hidden;
      .task-name {
        float: left;
        color: #303133;
      }
      .export_btn {
        float: right;
      }
    }

    ::v-deep .search_form {
      .el-form-item {
        margin-right: 30px;
        .el-input-group__append {
          background-color: #409eff;
          border-color: #409eff;
          color: #fff;
        }
      }
    }
    ::v-deep .student-list,
    ::v-deep .question-list {
      .is-leaf {
        color: #333;
        background-color: #f5f5f5;
      }
    }
    // ::v-deep .foot_page {
    //   margin-top: 20px;
    //   text-align: right;
    //   .el-pagination__total {
    //     float: left;
    //   }
    // }
  }
  .el-input-number {
    width: 70px;
  }
}
</style>